const entityType = Object.freeze({
    APARTMENT: 'apartment',
    STAIRWELL: 'stairwell',
    BUILDING: 'building',
    RESIDENCE: 'residence'
});

export default entityType;